<template>
    <div id="dashboard-currency" class="currency" @click="toggler()">
        <BaseIconTitle
            :title="tokens.newDesign.dashboardCurrency"
            :material-icon="'price_check'"
        />

        <BaseSelectModalBox
            :position="selectPosition"
            :placeholder="currency"
            :options="Object.entries(currencies).map(([key, value]) => ({
                    key: value,
                    title:value ? value : 'USD',
                }))
            "
            :state="state"
            v-model="currency"
            @update="changeCurrency"
        >
            <template #option="{option}">
                <img :src="getCurrencyImage(option.key ? option.key : 'USD')" alt="">
                <div class="name">{{ option.title }}</div>
            </template>
        </BaseSelectModalBox>
    </div>
</template>

<script>
import BaseIconTitle from "@/new-design/shared/ui/titles/BaseIconTitle.vue"
import BaseSelectModalBox from "@/new-design/shared/ui/Inputs/BaseSelectModalBox.vue"
import {ACTIVE_CURRENCY} from "@/store/mutations.type"
import {mapGetters} from "vuex"
import toggler from "@/new-design/shared/mixins/toggler"

const currencies = require.context(
    '@/assets/image/currencies',
    false,
    /\.png$/
)

export default {
    name: "DashboardCurrency",
    components: {BaseSelectModalBox, BaseIconTitle},
    mixins: [toggler],
    props: {
        selectPosition: {
            type: String,
        }
    },
    data(){
        return {
            currency: localStorage.getItem('activeCurrency') || this.activeCurrency
        }
    },
    computed: {
        ...mapGetters(['currencies', 'activeCurrency','modals', 'activePage', 'tokens','staticBase'])
    },
    methods: {
        changeCurrency(currency) {
            localStorage.activeCurrency = currency
            this.$store.commit(ACTIVE_CURRENCY, currency)
        },
        getCurrencyImage(name) {
            const filePath = `./${name}.png`

            if (!currencies.keys().includes(filePath)) {
                return ''
            }

            const image = currencies(filePath)

            return image.default || image
        },
    },
    watch: {
        state(val) {
            const app =  document.getElementById('app')
            if (val && (this.modals.menuSettings || this.activePage === 'settings')) {
                const isMobile = app.classList.contains('mobile')

                if (!isMobile) {
                    return
                }

                app.classList.add('hidden')

                setTimeout(() => {
                    const dashboardElement = document.getElementById('dashboard-currency')
                    const dashboardPanel = document.getElementById('dashboard-panel')
                    if (dashboardElement) {
                        dashboardElement.style.position = 'static'
                    }

                    if (dashboardPanel) {
                        dashboardPanel.style.position = 'static'
                    }
                }, 1)
            } else {
                app.classList.remove('hidden')
            }
        },
        activeCurrency(val) {
            this.currency = val
        }
    }
}
</script>

<style scoped>
.currency {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
}

img {
    width: 20px;
    height: 20px;
    object-fit: cover;
}
</style>
